/** */
import {
  ADD_MANY_WORD_SEARCHES_TO_STORE,
  ADD_ONE_WORD_SEARCH_TO_STORE,
  REM_ONE_WORD_SEARCH_FROM_STORE
} from '../actions/word-search';

export default (state = {}, action) => {
  const { type, payload } = action;
  let previous_state;
  switch (type) {
    case ADD_MANY_WORD_SEARCHES_TO_STORE:
      return {
        ...state,
        ...payload.reduce(
          (word_searches, word_search) => ({
            ...word_searches,
            [word_search.id]: word_search
          }),
          {}
        )
      };
    case ADD_ONE_WORD_SEARCH_TO_STORE:
      return {
        ...state,
        [payload.id]: payload
      };
    case REM_ONE_WORD_SEARCH_FROM_STORE:
      previous_state = { ...state };
      delete previous_state[payload];
      return {
        ...previous_state
      };
    default:
      return state;
  }
};
